/** Time of day in Africa/Lusaka for receipts and reports. */
export function formatReceiptTime(iso: string | undefined, format: '24h' | '12h' = '24h') {
  if (!iso) return '—'
  return new Date(iso).toLocaleTimeString('en-GB', { timeZone: 'Africa/Lusaka', hour: '2-digit', minute: '2-digit', hour12: format === '12h' })
}

/** Lusaka calendar date (yyyy-mm-dd) of an ISO timestamp. */
export function lusakaDate(iso: string) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Lusaka', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(iso))
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? '01'
  return `${get('year')}-${get('month')}-${get('day')}`
}
